import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=cfb291d6&scoped=true"
import script from "./Message.vue?vue&type=script&lang=ts"
export * from "./Message.vue?vue&type=script&lang=ts"
import style0 from "./Message.vue?vue&type=style&index=0&id=cfb291d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb291d6",
  null
  
)

export default component.exports